export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const COMPANY_SIGNUP = "COMPANY_SIGNUP"
export const COMPANY_SIGNUP_SUCCESS = "COMPANY_SIGNUP_SUCCESS"
export const COMPANY_SIGNUP_ERROR = "COMPANY_SIGNUP_ERROR"

export const COMPANY_SETTING = "COMPANY_SETTING"
export const COMPANY_SETTING_SUCCESS = "COMPANY_SETTING_SUCCESS"

export const ACCESS_SETTING = "ACCESS_SETTING"
export const ACCESS_SETTING_SUCCESS = "ACCESS_SETTING_SUCCESS"

export const USER_DETAILS = "USER_DETAILS"
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS"

export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD"
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS"
export const CHANGE_USER_PASSWORD_ERROR = "CHANGE_USER_PASSWORD_ERROR"

// aplication once click redirect login to dashboard or verify screen
export const REDIRECT_LOGIN = "REDIRECT_LOGIN"
export const REDIRECT_LOGIN_SUCCESS = "REDIRECT_LOGIN_SUCCESS"
export const REDIRECT_LOGIN_ERROR = "REDIRECT_LOGIN_ERROR"
